import * as React from "react";

import { ToolbarToggle } from "./ToolbarToggle";
import { DOCUMENT_MAP_VIEW_MODES, type DocumentMapViewMode } from "./types";

const MODE_LABELS: Record<DocumentMapViewMode, string> = { list: "List", split: "Split", map: "Map" };

interface Props {
  value: DocumentMapViewMode;
  onChange: (mode: DocumentMapViewMode) => void;
}

export const DocumentMapViewControl: React.FC<Props> = ({ value, onChange }) => (
  <div role="group" aria-label="Document view" className="mb-3 flex gap-0.5">
    {DOCUMENT_MAP_VIEW_MODES.map(mode => (
      <ToolbarToggle key={mode} pressed={value === mode} onClick={() => onChange(mode)}>
        {MODE_LABELS[mode]}
      </ToolbarToggle>
    ))}
  </div>
);
